export enum PermissionRulesEnum {
  CanRegisterForTraining = 'can_register_for_training',
  CanRequestClass = 'can_request_class',
  CanApproveTraining = 'can_approve_training',
  CanEditTraining = 'can_edit_training',
  CanCompleteTraining = 'can_complete_training',
  CanCancelTraining = 'can_cancel_training',
  CanAddCourses = 'can_add_courses',
  CanEditCourses = 'can_edit_courses',
  CanCreateOwnProfile = 'can_create_own_profile',
  CanViewUnitProfiles = 'can_view_unit_profiles',
  CanEditUnitProfiles = 'can_edit_unit_profiles',
  CanViewAllProfiles = 'can_view_all_profiles',
  CanAccessDisasterProfile = 'can_access_disaster_profile',
  CanAccessAdminComponents = 'can_access_admin_components',
  CanChangeAccessLevel0To2 = 'can_change_access_level_0_to_2',
  CanChangeAccessLevel0To4 = 'can_change_access_level_0_to_4',
  CanAssociateUsersLocations = 'can_associate_users_locations',
  CanSignReleases = 'can_sign_releases',
  CanAccessDocumentLibrary = 'can_access_document_library',
  CanConfirmCredentialing = 'can_confirm_credentialing',
  CanPrintBadges = 'can_print_badges',
  CanManageOwnUnit = 'can_manage_own_unit',
  CanAssignWorkersToIncidents = 'can_assign_workers_to_incidents',
  CanViewDivisionalWorkers = 'can_view_divisional_workers',
  CanEditNewsArticles = 'can_edit_news_articles',
  CanChangeAccessLevel0To3 = 'can_change_access_level_0_to_3',
  CanChangeAccessLevel0To5 = 'can_change_access_level_0_to_5',
  CanApproveDisasterPhotoProfile = 'can_approve_disaster_photo_profile',
  CanApproveSatern = 'can_approve_satern',
  CanAddEditDocumentLibrary = 'can_add_edit_document_library',
CanAccessIncident = 'can_access_incident',
CanAddEditIncident = 'can_add_edit_incident',
  CanAddAuthorizedTrainer = 'can_add_authorized_trainer',
}
